import layout from '@/views/layout/layout.vue'
const wechatExcellentOrderList = r => require.ensure([], () => r(require('@/views/wechatExcellent/order/list.vue')), 'group-wechatExcellent-wechatExcellentOrder')
const wechatExcellentOrderTabsList = r => require.ensure([], () => r(require('@/views/wechatExcellent/order/tabslist.vue')), 'group-wechatExcellent-wechatExcellentOrderTabs')

const wechatExcellentOrder = [
  {
    path: '/wechatExcellent/order',
    name: 'wechatExcellent-order',
    component: layout,
    redirect: '/wechatExcellent/order/tabslist',
    hidden: true,
    children: [
      {
        path: 'list',
        component: wechatExcellentOrderList,
        name: 'wechatExcellent-order-list',
        meta: {
          displayName: '经销商订单管理',
          requireAuth: true
        }
      },
      {
        path: 'tabslist',
        component: wechatExcellentOrderTabsList,
        name: 'wechatExcellent-order-list',
        meta: {
          displayName: '订单管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default wechatExcellentOrder



// WEBPACK FOOTER //
// ./src/router/wechatExcellent/order.js